export default "__VITE_ASSET__ChQtgjoa__"